import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const FormAudioPlayer = ({ audio, setMin, setSec, flag, audioEl, id, setAudios, index }) => {
  const handleLoadedMetadata = () => {
    const video = audioEl && audioEl.current;
    if (!video) return;
    let minutes = Math.floor(video.duration / 60);
    let extraSeconds = video.duration % 60;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let sec = parseInt(extraSeconds);
    sec = sec < 10 ? '0' + sec : sec;
    setAudios &&
      setAudios((prev) => {
        const newAudios = [...prev];
        return newAudios?.map((data, i) => {
          if (i === index) {
            return { ...data, duration: minutes + ':' + sec };
          } else {
            return data;
          }
        });
      });
    setMin && setMin(minutes);
    setSec && setSec(sec);
  };

  function changeSource(url) {
    const video = document.getElementById('audio');
    if (video) video.src = url;
  }

  useEffect(() => {
    changeSource(audio);
  }, [audio]);

  return (
    <div className={flag ? 'mt-1' : 'mt-2'}>
      <audio
        id={id}
        onLoadedMetadata={handleLoadedMetadata}
        ref={audioEl}
        controls
        className="h-[42px]"
        style={{ width: '-webkit-fill-available' }}
      >
        <source src={audio} />
      </audio>
    </div>
  );
};

FormAudioPlayer.propTypes = {
  audio: PropTypes.any,
  setMin: PropTypes.func,
  setSec: PropTypes.func,
  setAudios: PropTypes.func,
  index: PropTypes.number,
  flag: PropTypes.func,
  audioEl: PropTypes.any
};

export default FormAudioPlayer;
